import PhotoReducer from "../reducers/PhotoReducer";
import BaseAction from "./BaseAction";

class PhotoAction extends BaseAction {
  onClose = () => {};

  open = async (message, title = "Error", onClose = () => {}) => {
    this.onClose = onClose;
    this.dispatch({ open: true, message, title });
  };
}

const action = new PhotoAction(PhotoReducer);

export default action;
